module.exports = __webpack_public_path__ + "img/uninstall-gbwhatsapp.d0d447c3.webp";